import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { productSearchApi, StoreResponse, StoreResponses } from '@/stores/api';
import { ProductSearchRequestDto, ProductSearchResultDto } from '@/api';
import { ProductSearchResult, ProductTuple, SearchUtility } from '@/stores/search/util';
import * as _ from 'lodash';
import ErrorKey from '@/util/ErrorKey';

@Module({
  namespaced: true,
  name: 'SearchBarStore',
})
export default class SearchBarStore extends VuexModule {
  private searchResult = _.cloneDeep(SearchUtility.EmptySearchResult);
  private searchRequest = _.cloneDeep(SearchUtility.EmptySearchRequest);
  private isBarActive = false;

  get currentSearchRequest(): ProductSearchRequestDto {
    return this.searchRequest;
  }

  get isSearchBarActive() {
    return this.isBarActive && this.searchResult.products.length > 0;
  }

  get currentProducts(): ProductTuple[] {
    return this.searchResult.products;
  }

  get currentSearchResult(): ProductSearchResult {
    return this.searchResult;
  }

  @Mutation
  public setSearchBarActive(isBarActive: boolean) {
    this.isBarActive = isBarActive;
  }

  @Action
  public async updateSearchRequest(searchRequest: ProductSearchRequestDto) {
    this.context.commit('setSearchRequest', searchRequest);
    await this.fetchProducts();
  }

  @Action
  public async fetchProducts(): Promise<StoreResponse<ProductSearchResultDto>> {
    try {
      if (this.searchRequest.queryString === '') {
        this.resetSearchResults();
        return StoreResponses.success(SearchUtility.EmptySearchResultDto);
      }
      const response = await productSearchApi.searchProducts('GRM', this.searchRequest);
      this.context.commit('setSearchResult', response.data);
      return StoreResponses.apiSuccess(response);
    } catch (e) {
      this.resetSearchResults();
      return StoreResponses.error(e, ErrorKey.ProductListFetchAction);
    }
  }

  @Action
  public resetSearchResults() {
    this.context.commit('setSearchResult', SearchUtility.EmptySearchResult);
    this.context.commit('setSearchRequest', SearchUtility.EmptySearchRequest);
  }

  @Mutation
  private setSearchResult(searchResult: ProductSearchResultDto) {
    this.searchResult.facets = searchResult.facets;
    this.searchResult.filter = searchResult.filter;
    this.searchResult.page = searchResult.page;
    this.searchResult.queryDurationMs = searchResult.queryDurationMs;
    this.searchResult.products = SearchUtility.splitByUnit(searchResult.products, searchResult.filter);
  }

  @Mutation
  private setSearchRequest(searchRequest: ProductSearchRequestDto) {
    this.searchRequest = searchRequest;
  }
}
